import type * as React from 'react'
import { cn } from '@/lib/utils'

interface BubbleProps extends React.ComponentProps<'div'> {
  readonly variant?: 'agent' | 'user' | 'error'
}

/** Balão de mensagem do chat de pós-graduação — agente à esquerda, usuário à direita. */
export function Bubble({ variant = 'agent', className, ...props }: BubbleProps) {
  return (
    <div
      className={cn(
        'w-fit max-w-[80%] rounded-2xl px-3.5 py-2 font-rethink text-sm leading-relaxed',
        variant === 'agent' && 'rounded-bl-md bg-[#F2F2F2] text-neutral-800',
        variant === 'user' && 'ml-auto rounded-br-md bg-primary-800 text-white',
        variant === 'error' && 'rounded-bl-md bg-red-50 text-red-700',
        className
      )}
      {...props}
    />
  )
}

interface OptionPillProps extends React.ComponentProps<'button'> {
  readonly selected?: boolean
}

export function OptionPill({ selected = false, className, ...props }: OptionPillProps) {
  return (
    <button
      className={cn(
        'rounded-full border px-3.5 py-2 font-rethink font-medium text-sm transition-colors',
        selected
          ? 'border-primary-800 bg-primary-800 text-white'
          : 'border-primary-200 bg-white text-primary-800 hover:bg-primary-100/40',
        className
      )}
      type="button"
      {...props}
    />
  )
}
